import { scaleLinear } from 'd3-scale'
import { interpolateRgb } from 'd3-interpolate'

const clusterHelper = {
  buildBins(quantiles){
    try {
      let singleRow = quantiles.q1 === quantiles.q4;
      if (singleRow)
        return [{"min": quantiles.q1, "max": quantiles.q4}];
      else
        return [
          {"min": quantiles.q1, "max": quantiles.q2},
          {"min": quantiles.q2, "max": quantiles.q3},
          {"min": quantiles.q3, "max": quantiles.q4},
          {"min": quantiles.q4, "max": Infinity}];
    } catch (e) {
      console.log(e)
    }
  },
  changePaintProperty(map, layerId, key, value) {
    if (map.getLayer(layerId) != null)
      map.setPaintProperty(layerId, key, value);
  },
  changeLayoutProperty(map, layerId, key, value) {
    if (map.getLayer(layerId) != null)
      map.setLayoutProperty(layerId, key, value);
  },
  getClusterCircleColor(initialColor, finalColor, bins){
    function rgb2hex(rgb){
      rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
      return (rgb && rgb.length === 4) ? "#" +
        ("0" + parseInt(rgb[1],10).toString(16)).slice(-2) +
        ("0" + parseInt(rgb[2],10).toString(16)).slice(-2) +
        ("0" + parseInt(rgb[3],10).toString(16)).slice(-2) : '';
    };

    let useMaxColor = bins.length === 1;
    let circleColor = [];
    let color = scaleLinear()
      .domain([0, bins.length])
      .range([initialColor.toLowerCase(),finalColor.toLowerCase()])
      .interpolate(interpolateRgb);

    bins.forEach(function(bin, index) {
      if (useMaxColor)
        circleColor.push([bin.min, color(bins.length)]);
      else
        circleColor.push([bin.min, color(index)]);
    });

    return {
      "circle-color": {
      "type": "interval",
      "property": "point_count",
      "stops": circleColor
      }
    };
  },
  getClusterCircleRadius(quantiles){
    let circleRadius = [];
    let bins = this.buildBins(quantiles);
    let minRadius = bins.length === 1 ? 60 : 25;

    bins.forEach(function(bin, index){
      circleRadius.push([bin.min, minRadius]);
      minRadius += 10;
    });

    return {
      "circle-radius": {
        property: "point_count",
        type: "interval",
        stops: circleRadius
      }
    };
  },
  refreshStyle(map, cluster) {
    try {
      let cl = "cluster-" + cluster.layer
      if (map.getLayer(cl) === null) return
      if (!cluster.datavis.quantiles.hasOwnProperty('q1')) {
        console.warn(`Não é possível atualizar o estilo do cluster:  ${cl}`)
        console.info(`Propriedade "quantiles" retornou vazia do backend`)
        return false
      }
      let quantiles = cluster.datavis.quantiles
      //let initialColor = cluster.datavis.initialColor
      //let finalColor = cluster.datavis.finalColor
      //let bins = this.buildBins(quantiles)
      //let circleColor = map.getPaintProperty(cl, "circle-color")
      let circleRadius = this.getClusterCircleRadius(quantiles)
      //let stopColors = circleColor["stops"]
      //let newColors = this.getClusterCircleColor(initialColor, finalColor, bins)
      //map.setPaintProperty(cl, 'circle-color', newColors["circle-color"])
      map.setPaintProperty(cl, 'circle-radius', circleRadius["circle-radius"])
    } catch (e) {
      console.log(e)
    }
  }
};

export default clusterHelper;
